import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getRiskOptions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("risk-options")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getRiskItems(ctx, params) {
      const link = params && params.year
        ? `risk-items/year/${params.year}`
        : "risk-items";

      return new Promise((resolve, reject) => {
        axiosIns
          .get(link)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getArchivedRiskItems(ctx, params) {
      const year = params && params.year ? params.year : new Date().getFullYear();
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`risk-items/archived/${year}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    archiveRiskItem(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`archiveRiskItem/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    createRiskItem(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveRiskItem", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    updateRiskItem({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`/updateRiskItem/${payload.id}`, payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    deleteRiskItem(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteRiskItem/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    createRiskOption({ commit }, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/risk-items/createOption", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    updateRiskRowOrder({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/risk-items/update-row-order", payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    generateRiskReport(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("generate-risk-report", payload, { responseType: "blob" })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
